import {format, parseISO} from 'date-fns'
import {Link} from 'gatsby'
import React, { useEffect } from 'react'
import styled from '@emotion/styled'

import {buildImageObj, cn, getBlogUrl} from '../lib/helpers'
import {imageUrlFor} from '../lib/image-url'
import PortableText from './portableText'

import ObserverTop from '../utils/observerTopNews'
import ObserverBottom from '../utils/observerBottomNews'
import { Waypoint } from 'react-waypoint';


import theme from '../utils/theme';
import {CommonTextStyles} from '../utils/styles'


const StyledLink = styled(Link)`
  text-decoration: none;
  color: inherit;
`

const Post = styled('article')`
  position: relative;
  text-align: center;
  ${CommonTextStyles};
  padding-top: 60px;
  padding-bottom: 100px;
  background-color: #E45A5A;

  &:before {
    content: '';
    position: absolute;
    right: 0;
    top: 0;
    left: 0;
    height: 1px;
    background-color: #E6E6E6;
    mix-blend-mode: multiply;
  }

  &:first-of-type {
    /*
    padding-top: 70px;
    */

    &:before {
      content: none;
    }
  }

  @media ${theme.breakpoints.lg} { 
    /*
    &:first-of-type {
      padding-top: 70px;
    }
    */

    padding-top: 120px;
    padding-bottom: 160px;
  }
`

const Inner = styled('div')`
  //max-width: 920px;
  margin: 0 auto;
  padding: 0 15px;

  @media ${theme.breakpoints.lg} { 
    max-width: 83%;
    padding: 0 20px
  }
`

const Title = styled('h3')`
  ${CommonTextStyles};
  font-style: italic;
  font-weight: inherit;
  margin: 0;
`

const Content = styled('div')`
  margin-top: 50px;
  text-align: left;

  a {
    font-style: italic;
    color: inherit;
    text-decoration: none;

    &:hover {
      opacity: 0.8;
    }
  }

  p:last-of-type {
    margin-bottom: 0;
  }
`




function BlogPostPreview (props) {

  // const title = format(props.publishedAt, 'DD.MM.YYYY')

  // Make sure that scrollProgress get a title on load
  useEffect(() => {
    if(props.isFirst) {
      props.setNewsTitles(format(parseISO(props.publishedAt), 'dd.MM.yyyy'))
    }
  },[])


  const onEnter = () => {
    if (typeof window !== 'undefined') {
      window.history.replaceState({}, '', `/news/${props.slug.current}`);
    }

    const title = format(parseISO(props.publishedAt), 'dd.MM.yyyy')
    title ? props.setNewsTitles(title) : props.setNewsTitles(null)
  }

  const onLeave = ({ currentPosition }) => {
    if(props.isFirst && currentPosition === Waypoint.below) {
      if (typeof window !== 'undefined') {
        window.history.replaceState({}, '', `/news`);
      }
    }
  }


  return (
    <>
      {/*
      <div>
        {props.mainImage && props.mainImage.asset && (
          <img
            src={imageUrlFor(buildImageObj(props.mainImage))
              .width(600)
              .height(Math.floor((9 / 16) * 600))
              .auto('format')
              .url()}
            alt={props.mainImage.alt}
          />
        )}
      </div>
      */}
      <Waypoint 
        bottomOffset='99%' 
        onEnter={onEnter}
        onLeave={onLeave}
      >
        <Post className='post' id={props.slug.current} ref={props.forwardRef}>
          {/*
          <ObserverTop 
            title={format(props.publishedAt, 'DD.MM.YYYY')} 
            setNewsTitles={props.setNewsTitles} 
            isFirst={props.isFirst}
            slug={props.slug.current}
          />
          */}
          <Inner>
            {/*<StyledLink
              to={getBlogUrl(props.publishedAt, props.slug.current)}
            >*/}
              <div>{format(parseISO(props.publishedAt), 'eeee, d MMM. yyyy')}</div>
            {/*</StyledLink>*/}
            <Title>{props.title}</Title>
            {props._rawBody && (
              <Content>
                <PortableText blocks={props._rawBody} />
              </Content>
            )}
          </Inner>
          {/*
          <ObserverBottom
            title={format(props.publishedAt, 'DD.MM.YYYY')} 
            setNewsTitles={props.setNewsTitles} 
            slug={props.slug.current}
            //isFirst={props.isFirst}
          />
          */}
        </Post>
      </Waypoint>
    </>
  )
}

export default BlogPostPreview
